import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchAllTests } from "../services/api";

export const getAllTest = createAsyncThunk(
  "getAllTest",
  async (categoryId, { rejectWithValue }) => {
    try {
      return await fetchAllTests(categoryId);
    } catch (error) {
      return rejectWithValue(error.message || "Failed to load tests");
    }
  }
);

const GetAllTestSlice = createSlice({
  name: "getAllTestReducer",
  initialState: {
    isLoading: false,
    data: null,
    error: null,
  },
  reducers: {
    clearGetAllTestData: (state) => {
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllTest.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getAllTest.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(getAllTest.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to load tests";
      });
  },
});

export const { clearGetAllTestData } = GetAllTestSlice.actions;
export default GetAllTestSlice.reducer;
